import { useCallback, useRef, useState } from 'react';
import { useAccountTagData } from '@hub/features/account-dashboard/hooks';
import { useStore } from '@hub/helpers/use-store';
import { useMediaQuery, useTheme } from '@mui/material';
import { DEFAULT_ACCOUNT } from '../../../../../../constants/default-account.constants';
import { useDashboard } from '../../../../../../contexts';
import { BREAKPOINTS } from '../constants';
// Removed unused type imports

/**
 * Custom hook for managing Header Title component state
 * Consolidates all state management and derived values
 */
export const useHeaderTitleState = () => {
  // Context data
  const { account, accountBalance } = useDashboard();

  // Theme and responsive state
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(BREAKPOINTS.DESKTOP));

  // Store data
  const {
    dataStore: { programStore },
  } = useStore();

  // Dropdown state
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const desktopAnchorRef = useRef<HTMLDivElement>(null);
  const mobileAnchorRef = useRef<HTMLDivElement>(null);

  // Derived data (always call hooks with safe fallback)
  const tagData = useAccountTagData(account || DEFAULT_ACCOUNT);
  const program = programStore.get(account?.programId || '');

  // Menu handlers
  const handleMenuToggle = useCallback(() => {
    setIsMenuOpen(!isMenuOpen);
  }, [isMenuOpen]);

  const handleMenuClose = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  // Anchor element selector
  const getCurrentAnchorEl = useCallback(() => {
    return isDesktop ? desktopAnchorRef.current : mobileAnchorRef.current;
  }, [isDesktop]);

  return {
    // Core data
    account,
    accountBalance,
    tagData,
    program,

    // Responsive state
    isDesktop,

    // Refs
    desktopAnchorRef,
    mobileAnchorRef,

    // Menu state
    isMenuOpen,
    handleMenuToggle,
    handleMenuClose,
    getCurrentAnchorEl,
  };
};
